import FileUpload from '@nkr/components/file-upload';
import { Alert } from 'react-bootstrap';
import { DropEvent, FileRejection } from 'react-dropzone';

interface IProps {
    files: File[],
    hasColumnHeaders: boolean,
    onFileDropped: (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => void,
    onRemoveFile: (name: string) => void,
    onHasColumnHeadersChange: (hasColumnHeaders: boolean) => void
}

const SelectFile = (props: IProps) => {
    return (
        <div>
            <Alert bsStyle='info' style={{ fontSize: 12 }}>
                The file, at minimum, must include the following columns:<br />
                <ul>
                    <li>Center (UNOS ID), Date</li>
                    <li>DD Transplants, LD Transplants, Waitlist Total, Waitlist Active</li>
                    <li>LD ABO A, LD ABO B, LD ABO AB, LD ABO O</li>
                    <li>LD Recipient ABO A, LD Recipient ABO B, LD Recipient ABO AB, LD Recipient ABO O</li>
                </ul>
            </Alert>

            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div style={{ marginRight: 10 }}>First row contain column headers?</div>
                <div>
                    <label className='radio-inline'>
                        <input
                            type='radio'
                            id='hasColumnHeadersYes'
                            name="hasColumnHeaders"
                            checked={props.hasColumnHeaders}
                            onClick={() => props.onHasColumnHeadersChange(true)}
                        /> Yes
                    </label>
                    <label className='radio-inline'>
                        <input
                            type='radio'
                            id='hasColumnHeadersNo'
                            name="hasColumnHeaders"
                            checked={!props.hasColumnHeaders}
                            onClick={() => props.onHasColumnHeadersChange(false)}
                        /> No
                    </label>
                </div>
            </div>

            <FileUpload
                label='Select data file...'
                files={props.files}
                onFileDropped={props.onFileDropped}
                onRemoveFile={props.onRemoveFile}
                singleUploadOnly={false}
            />
        </div >
    );
}

export default SelectFile;